// @flow
import React, { PureComponent } from "react";
import classNames from "classnames";

type Props = {
  height: number,
  width: number,
  className: any
};

class Play extends PureComponent<Props> {
  render() {
    const { height, width, className } = this.props;
    const classes = classNames("icone", className);

    return (
      <svg className={classes} height={height} width={width} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
        <title>Ícone play</title>
        <desc>Ícone de um círculo com símbolo de play</desc>
        <g id="icon-play">
          <path d="M16,8A8,8,0,1,1,8,0,8,8,0,0,1,16,8ZM8,2a6,6,0,1,0,6,6A6,6,0,0,0,8,2ZM6,6v4a1,1,0,0,0,1.71.71l2-2a1,1,0,0,0,0-1.42l-2-2A1,1,0,0,0,6,6Z" />
        </g>
      </svg>
    );
  }
}

export default Play;
